module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-504.dbc537f.woff2";